/* eslint-disable camelcase */
import { Arr } from '@deqo/foundation';
import { ProfileData } from '../../../api/endpoints/me';
import { HandwritingFontList } from '../../../platform/assets/InAppFontList';
import { ColorList } from '../../../ui';
import { FakePeople } from './FakePeople';

const register = new Map<string, any>();

const get = (id: string) => {
    return register.get(id);
};

const create = (base?: { id: string, first_name: string, last_name: string, email: string }) => {
    const { id, first_name, last_name, email } = base ?? Arr.random(FakePeople);
    const inst: ProfileData = {
        id,
        legacyId: null,
        type: 1,
        name: `${first_name} ${last_name}`,
        shortName: first_name,
        initials: `${first_name[0]}${last_name[0]}`,
        email,
        emailSubscribed: false,
        emailVerified: true,
        photo: null,
        external: false,
        color: Arr.random(ColorList),
        handwriting: Arr.random(HandwritingFontList).name,
        accounts: [],
        connections: [],
        credentials: [],
        integrations: { calendar: false },
        createdAt: new Date(),
    };
    register.set(id, inst);
    return inst;
};

export const KioskUser = {
    me: create({ id: 'US00000KIOSK', first_name: 'Kiosk', last_name: 'User', email: 'kiosk@deqo.io' }),
    get,
    create,
};
